import { CheckoutState } from '../../state';
import { getEmailToPrefill } from '../../utils/user';
import { getBuyerEmailFromSurveyData } from '../forms';

export const getEmailToPrefillFirstAttendeeInfo = (state: CheckoutState) =>
    getBuyerEmailFromSurveyData(state) || getEmailToPrefill(state);
